<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Список программ (расширенный)</h3>
                <v-card
                        width="400px"
                >
                    <v-card-text>
                        <v-checkbox
                                v-model="is_inventory"
                                label="Включенное ПО в инвентаризационную ведомость"
                        ></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            :loading="listLoading.includes('downloadReportFullAccountingSoftwareList')"
                            @click.native="downloadReport()"
                    >Сформировать отчет
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
  data () {
    return {
      is_inventory: true
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    }
  },
  methods: {
    downloadReport () {
      this.$store.dispatch('ASReports/downloadReportFullAccountingSoftwareList', { is_inventory: this.is_inventory })
    }
  }
}
</script>
